module.exports = __webpack_public_path__ + "public/SiteIcons/reviewStar.svg?a727700f";